module.exports = __webpack_public_path__ + "img/home-run.98af1fe3.svg";